import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useState, useEffect } from 'react';

/**
 * Limitiert die Aufrufe eines Wertes per Debounce
 * @param {*} value
 * @param {number} [timeout=500] - Abwarten bis zum nächsten Ausführen (in ms)
 * @returns {*}
 */
export default (function (value) {
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  var _useState = useState(value),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  useEffect(function () {
    var handler = setTimeout(function () {
      return setState(value);
    }, timeout);
    return function () {
      return clearTimeout(handler);
    };
  }, [value, timeout]);
  return state;
});